<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (navbar.userAccess?.Follow_up=='Full' || navbar.userAccess?.Follow_up=='Readonly') {
<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			{{pagetitle}}
		</h5>
	</div>
	<div class="card-body">
		<div class="row g-1">
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<ng-select appendTo="body" [items]="stateList" bindLabel="stateName" bindValue="stateID"
					[clearable]="true" [multiple]="false" [(ngModel)]="filters.state" placeholder="State"
					[appearance]="'outline'" (change)="getCitiesByState();refreshTable();">
				</ng-select>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<ng-select appendTo="body" [items]="cityList" bindLabel="cityName" bindValue="cityID" [clearable]="true"
					[multiple]="false" [(ngModel)]="filters.city" placeholder="City" [appearance]="'outline'"
					(change)="getHospitalList();refreshTable();">
				</ng-select>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<ng-select appendTo="body" [items]="hospitalList" bindLabel="name" bindValue="id" [clearable]="true"
					[multiple]="false" [(ngModel)]="filters.hospital" placeholder="Hospital" [appearance]="'outline'"
					(change)="refreshTable();">
				</ng-select>
			</div>
		</div>
		<div class="table-responsive">
			<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover">
				<thead>
					<tr>
						<th style="width: 20% !important;">ICD Code</th>
						<th style="width: 20% !important;">Hospital</th>
						<th style="width: 20% !important;">Treatment</th>
						<th style="width: 20% !important;">Amount</th>
						<th style="width: 10% !important;">File</th>
						<th style="width: 10% !important;">Action</th>
					</tr>
				</thead>
				@if (dataList?.length) {
				<tbody>
					@for (v of dataList; track $index) {
					<tr>
						<td>{{ v.icd_code }}</td>
						<td>{{ v.hospital_name }}</td>
						<td>{{ v.treatment }}</td>
						<td>{{ v.amount }}</td>
						<td>
							@if (v.quotation) {
							<div class="icon-container no-delete">
								<file-icon [file]="v.quotation"></file-icon>
							</div>
							}
						</td>
						<td>
							<app-treatment-cost-form [id]="v.enc_id" [btn_type]="2" class="me-1"
								(created)="refreshTable()">
							</app-treatment-cost-form>
							<button class="btn btn-xs btn-danger" matTooltip="Delete" (click)="deleteConfirm(v.enc_id)">
								@if (showDeleteLoader === v.enc_id) {
								<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								}@else {
								<fa-icon [icon]="['fas', 'times']"></fa-icon>
								}
							</button>
						</td>
					</tr>
					}
				</tbody>
				}@else {
				<tbody>
					<tr>
						<td colspan="6" class="text-center">No data found!</td>
					</tr>
				</tbody>
				}
			</table>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}